import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
import PesquisaClientes from '@/views/PesquisaClientes.vue';
import Clientes from '@/views/Clientes.vue';
import ContatosCliente from '@/views/ContatosCliente.vue';
import MilhagemCliente from '@/views/MilhagemCliente.vue';
import LiquidadoEmAberto from '@/views/LiquidadoEmAberto.vue';
import PesquisaFornecedores from '@/views/PesquisaFornecedores.vue';
import Fornecedores from '@/views/Fornecedores.vue';
import ContatosFornecedor from '@/views/ContatosFornecedor.vue';
import Saldos from '@/views/Saldos.vue';
import ContasAPagarReceber from '@/views/ContasAPagarReceber.vue';
import DetalhamentoCPCR from '@/views/DetalhamentoCPCR.vue';
import ReceitasDespesasSelecionaMesAno from '@/views/ReceitasDespesasSelecionaMesAno.vue';
import ReceitasDespesasResultado from '@/views/ReceitasDespesasResultado.vue';
import MapaProducao from '@/views/MapaProducao.vue';
import MapaProducaoSelecionaPeriodo from '@/views/MapaProducaoSelecionaPeriodo.vue';
import MapaProducaoVisualizaVenda from '@/views/MapaProducaoVisualizaVenda.vue';
import DependentesCliente from '@/views/DependentesCliente.vue'; 

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/cadastros',
    name: 'Cadastros',
    component: Home,
    props: true
  },
  {
    path: '/financeiro',
    name: 'Financeiro',
    component: Home,
    props: true
  },
  {
    path: '/lembretes',
    name: 'Lmebretes',
    component: Home,
    props: true
  },
  {
    path: '/financeiro/:opcao',
    name: 'Home',
    component: Home,
    props: true
  },
  {
    path: '/pesquisarclientes',
    name: 'PesquisaClientes',
    component: PesquisaClientes
  },
  {
    path: '/pesquisarfornecedores',
    name: 'PesquisaFornecedores',
    component: PesquisaFornecedores
  },
  {
    path: '/clientes/:id',
    name: 'Clientes',
    component: Clientes,
    props: true
  },
  {
    path: '/dependentescliente/:id',
    name: 'DependentesCliente',
    component: DependentesCliente,
    props: true
  },{
    path: '/contatoscliente/:id',
    name: 'ContatosCliente',
    component: ContatosCliente,
    props: true
  },{
    path: '/milhagemcliente/:id',
    name: 'MilhagemCliente',
    component: MilhagemCliente,
    props: true
  },
  {
    path: '/liquidadoemaberto/:id/:tipo',
    name: 'LiquidadoEmAberto',
    component: LiquidadoEmAberto,
    props: true
  },{
    path: '/fornecedores/:id',
    name: 'Fornecedores',
    component: Fornecedores,
    props: true
  },{
    path: '/contatosfornecedor/:id',
    name: 'ContatosFornecedor',
    component: ContatosFornecedor,
    props: true
  },{
    path: '/saldos',
    name: 'Saldos',
    component: Saldos

  },{
    path: '/contasapagarreceber/:tipo/:periodo',
    name: 'ContasAPagarReceber',
    component: ContasAPagarReceber,
    props: true
  },{
    path : '/detalhamentocpcr/:tipo/:dt',
    name: 'DetalhamentoCPCR',
    component: DetalhamentoCPCR,
    props: true
  },{
    path : '/receitasdespesas/:regime',
    name : 'ReceitasDespesasSelecionaMesAno',
    component: ReceitasDespesasSelecionaMesAno,
    props: true
  },{
    path : '/receitasdespesas/:regime/:mes/:ano/:detalhamento',
    name : 'ReceitasDespesasResultado',
    component: ReceitasDespesasResultado,
    props: true
  },{
    path : '/detalharreceitasdespesas/:regime/:mes/:ano/:detalhamento',
    name : 'ReceitasDespesasResultado',
    component: ReceitasDespesasResultado,
    props: true
  },
  {
    path : '/mapaproducao/:dtinicio/:dtfim/:pagina',
    name : 'MapaProducao',
    component: MapaProducao,
    props: true
  },{
    path : '/mapaproducao/selecionarperiodo',
    name : 'MapaProducaoSelecionaPeriodo',
    component : MapaProducaoSelecionaPeriodo
  },{
    path : '/mapaproducao/venda/:id_vs',
    name : 'MapaProducaoVisualizaVenda',
    component : MapaProducaoVisualizaVenda,
    props: true
  }
]


const router = new VueRouter({
  routes
})


export default router
